import moment from 'moment';
import Constants from '../model/AppConfiguration';
import FlightsScreenController from '../containers/flights/FlightsScreenController';
import NotificationsConverter from './NotificationsConverter';
import NavigationConverter from './NavigationConverter';
import TripConverter from './TripConverter';

export default {
  passengerWireToInt: passengerWireToInt,
  passengerIntToWire: passengerIntToWire,
};

function passengerWireToInt (wirePassenger) {
  const {
    action,
    gototab,
    redirecturl,
    reservationid,
    tripType,
    settings,
    notifications,
  } = wirePassenger;
  let passengerId = wirePassenger.contact_objectid ? wirePassenger.contact_objectid._text : '';
  wirePassenger = wirePassenger ? wirePassenger.contact : {};
  const {
    contact_objectid,
    fname,
    lname,
    relationshiptype_objectid,
    contactDOB,
    age,
    agestatus,
    email,
    primaryPhone,
    gender,
    is_infant,
    is_editable,
  } = wirePassenger;
  let birthday = contactDOB ? contactDOB._text : '';
  birthday = birthday ?
    moment(birthday, Constants.SERVER_DATE_FORMAT).format(Constants.DATE_FORMAT) :
    new Date();
  let reservationId = reservationid ? parseInt(reservationid._text, 10) : 0;
  let trip = TripConverter.tripWireToInt(tripType);
  let goToTab = gototab ? gototab._text : '';
  let redirectUrl = redirecturl ? redirecturl._text : '';
  let navigation = NavigationConverter.navigationWireToInt(settings);
  let intNotifications = NotificationsConverter.notificationsWireToInt(notifications);
  return {
    general: {
      reservationId,
      passengerId,
      trip,
      action: 'Passengers',
      goToTab,
      redirectUrl,
      navigation,
      notifications: intNotifications,
    },
    passenger: {
      id: contact_objectid ? contact_objectid._text || 0 : 0,
      firstName: fname ? fname._text || '' : '',
      lastName: lname ? lname._text || '' : '',
      relationshipType: relationshiptype_objectid ? relationshiptype_objectid._text || '' : '',
      birthday,
      birthdayPreview: FlightsScreenController.formatDateLongMonthWithDay(birthday),
      email: email ? email._cdata || '' : '',
      infant: is_infant ? (is_infant._text ? parseInt(is_infant._text, 10) : 0) : 0,
      age: age ? (age._text ? parseInt(age._text, 10) : 0) : 0,
      ageStatus: agestatus ? agestatus._text || '' : '',
      phone: primaryPhone ? primaryPhone._text || '' : '',
      gender: gender ? (gender._text ? gender._text.toLowerCase() : '') : '',
      // editable: is_editable === 'true' || is_editable === true,
    },
  };
}

function passengerIntToWire (intPassenger, general) {
  const {
    id,
    firstName,
    lastName,
    relationshipType,
    // age,
    // ageStatus,
    email,
    gender,
    phone,
    birthday,
    infant,
    // editable,
  } = intPassenger;
  return {
    result: {
      action: 'savePassenger',
      reservationId: general ? general.reservationId : '',
      contact: {
        contact_objectid: id || 0,
        fname: firstName,
        lname: lastName,
        relationshiptype_objectid: relationshipType,
        // age: age,
        // agestatus: ageStatus,
        emailAddress: email,
        gender,
        primaryPhone: phone,
        contactDOB: birthday ? moment(birthday).format(Constants.SERVER_DATE_FORMAT) : '',
        is_infant: infant ? 1 : 0,
        // is_editable: editable ? 1 : 0,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/converter/PassengerDetailConverter.js